import { useMutation, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { ActiveConnection, DashboardSummary } from "@/types/api";

export function useDashboardSummary() {
  return useQuery({
    queryKey: ["dashboard", "summary"],
    queryFn: async () => (await api.get<DashboardSummary>("/api/dashboard/summary")).data,
    refetchInterval: 5_000,
  });
}

export function useActiveConnections() {
  return useQuery({
    queryKey: ["connections", "active"],
    queryFn: async () =>
      (await api.get<ActiveConnection[]>("/api/connections/active")).data,
    refetchInterval: 2_000,
  });
}

export function useConfigApply() {
  return useMutation({
    mutationFn: async () =>
      (await api.post<{ applied: boolean; regenerated_files: string[] }>(
        "/api/config/apply",
      )).data,
  });
}
